module.exports = "/_next/static/images/Hero@2x-747a91c18edfbd0fa6b341a1eb530ad1.png";